import React, { Fragment, useRef } from 'react'
import { NavLink } from 'react-router-dom'
import { GrClose } from "react-icons/gr"
import CircularProgressbar from '../Dashboard/AssetAllocation/CircularProgressbar'
import WebService from '../../../utility/WebService'
import { useEffect, useState } from "react";
import HelperService from '../../../utility/HelperService'
import { goalIcon } from '../../../utility/goalIcon';
import { CgClose } from 'react-icons/cg';
import { BsPlusCircle, BsQuestionCircle, BsPieChart, BsCircleFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import WarningModal from "../../../components/Warning/Warning";
import SucessModal from "../../../components/SucessModal/Sucess";
import { useForm } from "react-hook-form";
import { Label } from '../../../components/Label/Label'
import CircularProgressbarDisplay from '../../Admin/FinancialPlanning/AssetMapping/CircularProgressbarDisplay';
import ArcheivedGoalsPopUp from '../../DataEntryOperator/Goals/ArcheivedGoalsPopUp';
import {
    GridContextProvider,
    GridDropZone,
    GridItem,
    swap,
    move
} from "react-grid-dnd";
import { SkeletonBar } from "../../../components/Skeleton/Skeleton"; // pulls in the .cd-skl shimmer styles
//@ts-ignore
import "./Goals.css";

/* ---- inline line-icons (match the Client Dashboard icon set) ---- */
const IconDrag = () => (
    <svg viewBox="0 0 24 24" fill="currentColor"><circle cx="9" cy="6" r="1.6" /><circle cx="15" cy="6" r="1.6" /><circle cx="9" cy="12" r="1.6" /><circle cx="15" cy="12" r="1.6" /><circle cx="9" cy="18" r="1.6" /><circle cx="15" cy="18" r="1.6" /></svg>
);
const IconAllocation = () => (
    <svg viewBox="0 0 24 24"><path d="M12 3a9 9 0 1 0 9 9h-9z" /><path d="M12 3v9h9a9 9 0 0 0-9-9z" /></svg>
);
const IconEdit = () => (
    <svg viewBox="0 0 24 24"><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></svg>
);
const IconArchive = () => (
    <svg viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="4" rx="1" /><path d="M5 8v11h14V8M10 12h4" /></svg>
);
/* goalIcon moved to utility/goalIcon.tsx (shared single source of truth so the
   /goals list and the Assign-product modal stay in sync). Imported above. */

/* page-specific loading skeleton — shimmer blocks shaped like the goal cards */
const GoalsGridSkeleton = () => (
    <div className="gp-skl-grid">
        {Array.from({ length: 6 }).map((_, i) => (
            <div className="gp-skl-card" key={i}>
                <div className="gp-chead">
                    <span className="cd-skl" style={{ width: 22, height: 22, borderRadius: 7 }} />
                    <span className="cd-skl" style={{ width: 34, height: 34, borderRadius: 10 }} />
                    <span className="cd-skl" style={{ flex: 1, height: 14, borderRadius: 6 }} />
                </div>
                <div className="gp-body">
                    <div className="gp-metrics">
                        {Array.from({ length: 3 }).map((_, j) => (
                            <div className="gp-metric" key={j}>
                                <SkeletonBar w={92 + j * 20} h={11} />
                                <SkeletonBar w={74} h={12} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="gp-prog">
                    <div className="gp-prog-top">
                        <SkeletonBar w={54} h={10} />
                        <SkeletonBar w={34} h={13} />
                    </div>
                    <SkeletonBar w="100%" h={12} r={7} />
                </div>
                <div className="gp-foot">
                    <div className="gp-pill">
                        <SkeletonBar w={58} h={9} />
                        <SkeletonBar w={84} h={14} style={{ marginTop: 4 }} />
                    </div>
                    <div className="gp-pill gp-gap">
                        <SkeletonBar w={58} h={9} />
                        <SkeletonBar w={84} h={14} style={{ marginTop: 4 }} />
                    </div>
                </div>
                <div className="gp-acts">
                    <span className="cd-skl" style={{ flex: 1, height: 34, borderRadius: 9 }} />
                    <span className="cd-skl" style={{ flex: 1, height: 34, borderRadius: 9 }} />
                    <span className="cd-skl" style={{ flex: 1, height: 34, borderRadius: 9 }} />
                </div>
            </div>
        ))}
    </div>
);

const GoalsComponent = (props: any) => {
    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors },
    } = useForm();
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const cancelButtonRef = useRef(null);
    const cancelButtonRef3 = useRef(null);
    const [showLoader, setShowLoader] = useState(false);
    const [goals, setGoals] = useState<any[]>([]);
    const [pIChartPopup, setPIChartPopup] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [goalName, setGoalName] = useState('');
    const [goalNature, setGoalNature] = useState('');
    const [assetEarmarkedList, setAssetEarmarkedList] = useState<any[]>([]);

    const [riskProfile, setRiskProfile] = useState<any>();
    const [assetsInRule, setAssetInRule] = useState<any[]>([]);
    const [isShoWDeleteModal, setShowDeleteModal] = useState(false);
    const [deletedData, setDeletedData] = useState<any>({});
    const [doughnutLabelData, setLabeldonutData] = useState<any[]>([]);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);

    const [assetsInMannual, setAssetInMannual] = useState<any[]>([]);
    const [addAssetsPopup, setAddAssetsPopup] = useState(false)
    const [addAssetMannualPopup, setAddAssetMannualPopup] = useState(false)
    const [doughnutData, setDoughnutData] = useState<any[]>([]);
    const [doughnutData2, setDoughnutData2] = useState<any[]>([]);
    const [doughnutBackgroundColorData, SetDoughnutBackgroundColorData] = useState<any[]>([]);
    const [doughnutBackgroundColorData2, SetDoughnutBackgroundColorData2] = useState<any[]>([]);
    const [doughnutLabelData2, setLabeldonutData2] = useState<any[]>([]);
    const [priorityData, setPriorityData] = useState<any[]>([]);
    const [goalMaturityDate, setGoalMaturityDate] = useState('');
    const [goalsLiabilitiesDetailsId, setGoalsLiabilitiesDetailsId] = useState(0);
    const [assetListDefinedInRule, setAssetListDefinedInRule] = useState<any[]>([]);
    const [assetListDefinedInMannual, setAssetListDefinedInMannual] = useState<any[]>([]);
    const [goalMaturityRequiredAmount, setGoalMaturityRequiredAmount] = useState(0);
    const [CustomerFinancialPlanningId, setCustomerFinancialPlanningId] = useState(0);
    const [changedPriorityGoals, setChangedPriorityGoals] = useState<any[]>([]);
    const [isMapped, setIsMapped] = useState(false);
    const [selfTenure, setSelfTenure] = useState('');

    // Controls: Edit icon, Delete icon, and drag-to-reorder priority.
    // Pass isEditable={false} on the display-only page; defaults to true.
    const isEditable: boolean = props.isEditable ?? true;

    let cfpId = localStorage.getItem('cfpid');
    let history = useNavigate();

    useEffect(() => {
        getCustomerFinancialPlanningId();
        getDetail();
        changePriority();
    }, []);
    const getCustomerFinancialPlanningId = () => {

        WebService.getAPI({
            action: `/v2/CustomerFinancialPlanning/GetCustomerFinancialPlanningIDV2?customer_basics_id=${props.customer_basics_id}`,
            //body: null,
        }).then((res: any) => {
            setCustomerFinancialPlanningId(res.id)
        }).catch((e) => {

        });
    }
    useEffect(() => {
        // console.log('goals details are....', changedPriorityGoals);
        changePriority();
    }, [changedPriorityGoals])
    const getDetail = () => {

        setShowLoader(true);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/GoalsLiabilitiesDetailsList?is_active=${1}`,
            body:
            {
                customer_basics_id: props.customer_basics_id
            }
        })
            .then((res: any) => {
                setGoals(res.list)
                setShowLoader(false);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };
    const changePriority = () => {
        // Guard: don't call the reorder API from a display-only instance either.
        if (!isEditable) return;

        setShowLoader(true);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/SetPriority`,
            body: JSON.stringify(changedPriorityGoals),
        })
            .then((res: any) => {
                // getDetail();
                setShowLoader(false);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };
    //Below function used on click of show PI chard of goal widzard
    const getMappedAssetsForGoal = (goals_liabilities_details_id: any) => {
        //setLoading(true)
        setGoalsLiabilitiesDetailsId(goals_liabilities_details_id);

        WebService.getAPI({
            action: `/v2/AssetMappingActivity/GetMappedAssets?customer_financial_planning_id=${CustomerFinancialPlanningId}&goals_liabilities_details_id=${goals_liabilities_details_id}`,
            body: null,
        }).then((res: any) => {
            setGoalName(res.goal_name);
            setGoalNature(res.goal_nature);
            setGoalMaturityDate(res.maturity_date);
            setSelfTenure(res.self_tenure);

            if (res.goal_liability_name != 33) {
                setGoalMaturityRequiredAmount(res.goal_maturity_required);
            } else {
                setGoalMaturityRequiredAmount(0);
            }
            getRiskProfileDetails();
            setAssetEarmarkedList(res.list); //ITs actually mapped asset to goal list

            setPIChartPopup(true);
            setLoading(false)

        }).catch((e) => {

        });
    }
    const PIChartDetails = (goals_liabilities_details_id: number, customer_basics_id: number) => {
        setLoading(true)
        setGoalsLiabilitiesDetailsId(goals_liabilities_details_id)

        WebService.getAPI({
            action: `/v2/AssetMappingActivity/PIChartDetails?cbid=${customer_basics_id}&goals_liabilities_details_id=${goals_liabilities_details_id}`,
            body: null,
        }).then((res: any) => {
            setDoughnutData(res.doughNut.data);
            setLabeldonutData(res.doughNut.label);
            SetDoughnutBackgroundColorData(res.doughNut.backgroundColor);

            setDoughnutData2(res.doughNut2.data);
            setLabeldonutData2(res.doughNut2.label);
            SetDoughnutBackgroundColorData2(res.doughNut2.backgroundColor);

            // risk rating for this goal's client, computed & returned by PIChartDetails
            if (res.risk_rating) setRiskProfile(res.risk_rating);

            getMappedAssetsForGoal(goals_liabilities_details_id); //loading false in this function

        }).catch((e) => {

        });
    };
    const getRiskProfileDetails = () => {
        WebService.getAPI({
            action: `/v2/NewRiskProfileAnswerDetails/getRiskProfileRating?customer_financial_planning_id=${CustomerFinancialPlanningId}`,
            body: null,
        }).then((res: any) => {
            // don't clobber the value already set from PIChartDetails with an empty result
            if (res.list?.risk_rating) setRiskProfile(res.list.risk_rating);
        }).catch((e) => {

        });
    };


    const onDeleteGoal = (data: any) => {
        setShowLoader(true);
        var obj = {
            id: data.id,
            value: data.name,
            customer_basics_id: data.customer_basics_id
        };
        setDeletedData(obj);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/DeleteReason?id=${data.id}`,
            body: data,
        })
            .then((res: any) => {
                setShowLoader(false);
                console.log(res.message)
                if (res.message === 'No Mapped') {
                    setValue("reason", '');
                    setOpen2(true);
                    setIsMapped(false);
                }
                else {
                    setShowLoader(false);
                    setValue("reason", '');
                    setOpen2(true);
                    setIsMapped(true);
                }
            })
            .catch((e) => {
                setShowLoader(false);
            });
    };

    const DeleteReason = (data?: any) => {
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/Delete?id=${deletedData.id}&customer_basics_id=${props.customer_basics_id}`,
            body: data,
        })
            .then((res: any) => {
                setShowSucessModal(true);
                setSucessMessage(res.message)
                getDetail();
                setShowLoader(false);
            })
            .catch((e) => {
                setShowLoader(false);
                setShowWarningModal(true);
                setWarningMessage(e.message)
            });
    };
    const handgleDragEnd = (sourceId: any, sourceIndex: number, targetIndex: number, targetId: any) => {
        console.log('handle drag end.....', sourceId, "...", sourceIndex, "....", targetIndex, '.....', targetId);
        const result = handleMove(goals, sourceIndex, targetIndex);
        setGoals(result)
        const changedPriorityResult = result.map((item: any, idx: number) => {
            return { ...item, priority: idx + 1 };
        })
        return setChangedPriorityGoals(changedPriorityResult);
    };
    const handleMove = (array: any, fromIndex: number, toIndex: number) => {
        const arrayCopy = Array.from(array);
        const [movedItem] = arrayCopy.splice(fromIndex, 1);
        arrayCopy.splice(toIndex, 0, movedItem);
        return arrayCopy;
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }

    /**
     * Renders one goal card's inner content. Shared between the draggable
     * (isEditable) and plain (display-only) grids so the markup never drifts
     * out of sync between the two modes.
     */
    const renderGoalCard = (res: any, index: number) => {
        var mapped_percentage = res.mapped_percentage <= 0 ? 8 : res.mapped_percentage;
        if (res.mapped_percentage > 0 && res.goal_liability_name == 33) {
            res.mapped_percentage = 100;
        }
        const pct = parseInt(res.mapped_percentage) || 0;
        const barCol = pct >= 100 ? 'linear-gradient(90deg,#43cf7c,#2e9e6b)' : pct <= 0 ? 'linear-gradient(90deg,#9b81f2,#7b5aec)' : 'linear-gradient(90deg,#ffb14d,#ff8a00)';
        const pctCol = pct >= 100 ? '#2e9e6b' : pct <= 0 ? '#7b5aec' : '#d98a00';
        const barW = pct <= 0 ? 8 : Math.min(pct, 100);
        const shortfall = Number(res.difference) || 0;
        return (
            <div className="gp-card" title={res.display_goal ? res.display_goal : ''}>
                <div className="gp-chead">
                    <span className="gp-drag" title="Drag to reorder"><IconDrag /></span>
                    <span className="gp-prio">{index + 1}</span>
                    <span className="gp-gi">{goalIcon(res.display_goal)}</span>
                    <span className="gp-gname"><span className="gp-nm">{res.display_goal ? res.display_goal : "-"}</span></span>
                </div>
                <div className="gp-body">
                    <div className="gp-metrics">
                        <div className="gp-metric">
                            <span className="gp-k">Maturity date</span>
                            <span className={`gp-v ${res.maturity_date ? '' : 'gp-na'}`}>{res.maturity_date ? HelperService.getFormatedDateByDMY(res.maturity_date) : "NA"}</span>
                        </div>
                        <div className="gp-metric">
                            <span className="gp-k">Amount required today</span>
                            <span className={`gp-v ${res.proposed_amount ? '' : 'gp-na'}`}>{res.proposed_amount ? '₹' + HelperService.getCurrencyFormatterWithoutDecimal(res.proposed_amount) : "NA"}</span>
                        </div>
                        <div className="gp-metric">
                            <span className="gp-k">Amount required at maturity</span>
                            <span className={`gp-v ${res.maturity_amount_required ? '' : 'gp-na'}`}>{res.maturity_amount_required ? '₹' + HelperService.getCurrencyFormatterWithoutDecimal(res.maturity_amount_required) : "NA"}</span>
                        </div>
                    </div>
                </div>
                <div className="gp-prog">
                    <div className="gp-prog-top">
                        <span className="gp-prog-lbl">Funded</span>
                        <span className="gp-prog-pct" style={{ color: pctCol }}>{HelperService.getCurrencyFormatterWithoutDecimal(res.mapped_percentage)}%</span>
                    </div>
                    <div className="gp-gbar" title={HelperService.getCurrencyFormatterWithoutDecimal(res.mapped_percentage) + '%'}>
                        <i style={{ width: barW + '%', background: barCol }}></i>
                    </div>
                </div>
                <div className="gp-foot">
                    <div className="gp-pill">
                        <span className="gp-pk">Earmarked</span>
                        <span className="gp-pv">₹{HelperService.getCurrencyFormatterWithoutDecimal(res.earmarked)}</span>
                    </div>
                    <div className="gp-pill gp-gap">
                        <span className="gp-pk">Short amount</span>
                        <span className={`gp-pv ${shortfall > 0 ? 'gp-neg' : 'gp-pos'}`}>₹{HelperService.getCurrencyFormatterWithoutDecimal(res.difference)}</span>
                    </div>
                </div>
                <div className="gp-acts">
                    <button type="button" className="gp-act gp-alloc" title="Asset allocation" onClick={() => PIChartDetails(res.goals_liabilities_details_id, res.customer_basics_id)}><IconAllocation />Allocation</button>
                    {isEditable && (
                        <button type="button" className="gp-act gp-edit" title="Edit goal" onClick={() => history(`/goals/edit-goal/${res.goals_liabilities_details_id}`)}><IconEdit />Edit</button>
                    )}
                    {isEditable && (
                        <button type="button" className="gp-act gp-arch" title="Archive goal" onClick={() => onDeleteGoal({ id: res.goals_liabilities_details_id, name: res.display_goal, customer_basics_id: props.customer_basics_id })}><IconArchive />Archive</button>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            {/* <Loader show={isLoading} /> */}
            <div className="goalspage">
                {(showLoader && goals.length === 0) ?
                    <GoalsGridSkeleton />
                    : goals.length > 0 ?
                        (isEditable ? (
                            <GridContextProvider onChange={handgleDragEnd}>
                                <div className="gp-gridwrap">
                                    <GridDropZone
                                        id="priority"
                                        boxesPerRow={3}
                                        rowHeight={384}
                                        style={{
                                            flex: '1',
                                            height: Math.ceil(goals.length / 3) * 384 + "px" // rows × rowHeight
                                        }}
                                    >
                                        {goals && goals.map((res: any, index: any) => {
                                            if (res.mapped_percentage > 0 && res.goal_liability_name == 33) {
                                                res.mapped_percentage = 100; // Wealth Building Goal
                                            }
                                            const pct = parseInt(res.mapped_percentage) || 0;
                                            const barCol = pct >= 100 ? 'linear-gradient(90deg,#43cf7c,#2e9e6b)' : pct <= 0 ? 'linear-gradient(90deg,#9b81f2,#7b5aec)' : 'linear-gradient(90deg,#ffb14d,#ff8a00)';
                                            const pctCol = pct >= 100 ? '#2e9e6b' : pct <= 0 ? '#7b5aec' : '#d98a00';
                                            const barW = pct <= 0 ? 8 : Math.min(pct, 100);
                                            const shortfall = Number(res.difference) || 0;
                                            return (
                                                <GridItem key={res.priority}>
                                                    <div className="gp-card" title={res.display_goal ? res.display_goal : ''}>
                                                        <div className="gp-chead">
                                                            <span className="gp-drag" title="Drag to reorder"><IconDrag /></span>
                                                            <span className="gp-prio">{index + 1}</span>
                                                            <span className="gp-gi">{goalIcon(res.display_goal)}</span>
                                                            <span className="gp-gname"><span className="gp-nm">{res.display_goal ? res.display_goal : "-"}</span></span>
                                                        </div>
                                                        <div className="gp-body">
                                                            <div className="gp-metrics">
                                                                <div className="gp-metric">
                                                                    <span className="gp-k">Maturity date</span>
                                                                    <span className={`gp-v ${res.maturity_date ? '' : 'gp-na'}`}>{res.maturity_date ? HelperService.getFormatedDateByDMY(res.maturity_date) : "NA"}</span>
                                                                </div>
                                                                <div className="gp-metric">
                                                                    <span className="gp-k">Amount required today</span>
                                                                    <span className={`gp-v ${res.proposed_amount ? '' : 'gp-na'}`}>{res.proposed_amount ? '₹' + HelperService.getCurrencyFormatterWithoutDecimal(res.proposed_amount) : "NA"}</span>
                                                                </div>
                                                                <div className="gp-metric">
                                                                    <span className="gp-k">Amount required at maturity</span>
                                                                    <span className={`gp-v ${res.maturity_amount_required ? '' : 'gp-na'}`}>{res.maturity_amount_required ? '₹' + HelperService.getCurrencyFormatterWithoutDecimal(res.maturity_amount_required) : "NA"}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="gp-prog">
                                                            <div className="gp-prog-top">
                                                                <span className="gp-prog-lbl">Funded</span>
                                                                <span className="gp-prog-pct" style={{ color: pctCol }}>{HelperService.getCurrencyFormatterWithoutDecimal(res.mapped_percentage)}%</span>
                                                            </div>
                                                            <div className="gp-gbar" title={HelperService.getCurrencyFormatterWithoutDecimal(res.mapped_percentage) + '%'}>
                                                                <i style={{ width: barW + '%', background: barCol }}></i>
                                                            </div>
                                                        </div>
                                                        <div className="gp-foot">
                                                            <div className="gp-pill">
                                                                <span className="gp-pk">Earmarked</span>
                                                                <span className="gp-pv">₹{HelperService.getCurrencyFormatterWithoutDecimal(res.earmarked)}</span>
                                                            </div>
                                                            <div className="gp-pill gp-gap">
                                                                <span className="gp-pk">Short amount</span>
                                                                <span className={`gp-pv ${shortfall > 0 ? 'gp-neg' : 'gp-pos'}`}>₹{HelperService.getCurrencyFormatterWithoutDecimal(res.difference)}</span>
                                                            </div>
                                                        </div>
                                                        <div className="gp-acts">
                                                            <button type="button" className="gp-act gp-alloc" title="Asset allocation" onClick={() => PIChartDetails(res.goals_liabilities_details_id, res.customer_basics_id)}><IconAllocation />Allocation</button>
                                                            {isEditable && (
                                                                <button type="button" className="gp-act gp-edit" title="Edit goal" onClick={() => history(`/goals/edit-goal/${res.goals_liabilities_details_id}`)}><IconEdit />Edit</button>
                                                            )}
                                                            {isEditable && (
                                                                <button type="button" className="gp-act gp-arch" title="Archive goal" onClick={() => onDeleteGoal({ id: res.goals_liabilities_details_id, name: res.display_goal, customer_basics_id: props.customer_basics_id })}><IconArchive />Archive</button>
                                                            )}
                                                        </div>
                                                    </div>
                                                </GridItem>
                                            )
                                        })}
                                    </GridDropZone>
                                </div>
                            </GridContextProvider>
                        ) : (
                            // Display-only mode: plain grid, no drag, no Edit/Delete
                            <div className="grid grid-cols-3 gap-4 mx-[1rem]">
                                {goals.map((res: any, index: number) => (
                                    <div key={res.priority}>
                                        {renderGoalCard(res, index)}
                                    </div>
                                ))}
                            </div>
                        ))
                        : <div className="gp-empty">
                            <h2>No Goals Found</h2>
                        </div>
                }
            </div>

            <ArcheivedGoalsPopUp open2={open2} cancelButtonRef={cancelButtonRef} setOpen2={setOpen2} handleSubmit={handleSubmit} DeleteReason={DeleteReason} deletedData={deletedData} setDeletedData={setDeletedData} register={register} errors={errors} isMapped={isMapped}></ArcheivedGoalsPopUp>
            {/* PI Chart Graph modal  */}
            <CircularProgressbarDisplay isshowTable={true} goal_maturity_required={goalMaturityRequiredAmount} setPIChartPopup={setPIChartPopup} doughnutData2={doughnutData2} doughnutLabelData2={doughnutLabelData2} doughnutBackgroundColorData2={doughnutBackgroundColorData2} doughnutData={doughnutData} doughnutLabelData={doughnutLabelData} doughnutBackgroundColorData={doughnutBackgroundColorData} assetEarmarkedList={assetEarmarkedList} riskProfile={riskProfile} goalNature={goalNature} pIChartPopup={pIChartPopup} addAssetsPopup={addAssetsPopup} goalMaturityDate={goalMaturityDate} cancelButtonRef={cancelButtonRef} setAddAssetsPopup={setAddAssetsPopup} goalName={goalName} assetsInRule={assetsInRule} selfTenure={selfTenure} ></CircularProgressbarDisplay>
        </>
    )
}
export default GoalsComponent;